module.exports = __webpack_public_path__ + "img/small_PC.97898b2d.jpg";